import { Box, Stack, Typography } from '@mui/material';
import Sum from 'components/Sum';
import { BORDER_COLOR, BRIGHT_BLUE, CLOUD_MIST, LIGHT_BLACK } from 'utils/theme';
import Filter from '../Filter';

interface ResultsProps {
  claimsLength: number;
  isFilterAdjusted: boolean;
}

const ResultsHeader = ({ claimsLength, isFilterAdjusted }: ResultsProps) => {
  return (
    <Box
      sx={{
        background: 'white',
        border: `1px solid ${BORDER_COLOR}`,
        px: { mobile: '16px', tablet: '30px', desktop: '30px' },
        paddingTop: { mobile: 2, tablet: 2, desktop: 3 },
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        mb: isFilterAdjusted ? 0 : 2,
        mt: { mobile: '20px', tablet: '24px', desktop: '24px' },
        backgroundColor: 'white',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Box>
          <Typography>Results:</Typography>
          <Stack
            direction="row"
            alignItems="center"
            pb={2}
            pt={2}
            borderBottom={`2.5px solid ${BRIGHT_BLUE}`}
          >
            <Sum color={CLOUD_MIST} count={claimsLength} isSum={true} />
            <Typography variant="subtitle2" ml={1} color={LIGHT_BLACK}>
              ALL CLAIMS
            </Typography>
          </Stack>
        </Box>
        <Filter />
      </Stack>
    </Box>
  );
};

export default ResultsHeader;
